import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        pd6: null,
        insert: false,
        update: false,
        loading: false
    },
    getters: {
        
    },
    mutations: {
        set(state, pd6){
            state.pd6 = pd6
            if (pd6)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
        }
    },
    actions: {
        async find(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Pesquisando parâmetros de cheque", indeterminate: true }, {root: true})
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get("/Financial/ChequeParameters/Find")
            .then(response => {
                let pd6 = Utils.ValidateAxiosResponse(response.data);
                store.dispatch("pd7/setParamsDataTable", pd6 ? pd6.lstPd7 : [], { root: true })
                store.commit("set", pd6)
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
            store.state.loading = false
        },
        save(store){
            if (store.state.update){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/Financial/ChequeParameters/Insert", store.state.pd6 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/Financial/ChequeParameters/Update", store.state.pd6 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete("/Financial/ChequeParameters/Delete")
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
    }
}